import React, { useState, useEffect } from 'react';
import '../styles/App.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import BlogPost from "../components/BlogPost";
import {data, Link, useLocation, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {fetchBlogData} from "../utils/functions";

function BlogPage() {
    const [t, i18n] = useTranslation();
    const [blogData, setBlogData] = useState([]);
    // Define loading state here
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    // List of available tags
    const [availableTags, setAvailableTags] = useState([]);
    const [AllTag, setAllTag] = useState("All");
    useEffect(() => {
        const newAllTag = location.pathname.startsWith("/hk") ? "所有" : "All";
        setAllTag(newAllTag);

        // Update available tags when language changes
        const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : "en";
        fetch(`https://backend.activikid.hk/api/tags?populate=*&locale=${lang}`)
            .then(response => response.json())
            .then(data => {
                const transformedTags = data.data.map(item => item.attributes.tag);
                setAvailableTags([...transformedTags]);
            })
            .catch(console.error);
    }, [location.pathname]);


    // Use React Router's useSearchParams to read the ?tag= param
    const [searchParams, setSearchParams] = useSearchParams();
    const initialTag = searchParams.get("tag") || AllTag;

    // State for selected tag
    const [selectedTag, setSelectedTag] = useState(initialTag);

    // Update selectedTag if the URL changes
    useEffect(() => {
        const paramTag = searchParams.get("tag") || AllTag;
        setSelectedTag(paramTag);
    }, [searchParams, AllTag]);

    useEffect(() => {
        let isMounted = true;
        const lang = location.pathname.startsWith('/hk') ? "zh-Hant-HK" : "en";

        const loadData = async () => {
            try {
                const data = await fetchBlogData(lang);
                if (isMounted) {
                    setBlogData(data);
                }
            } catch (error) {
                console.error('Error loading blog data:', error);
            } finally {
                if (isMounted) setLoading(false);
            }
        };
        loadData();

        // Cleanup function
        return () => {
            isMounted = false;
        };
    }, [location.pathname]);
    console.log(blogData);
    const reversedBlogData = [...blogData].reverse();
    // Filter blogs based on the selected tag
    let filteredBlogs = reversedBlogData.filter(blog =>
        selectedTag === AllTag ? true : blog.tag?.includes(selectedTag)
    );
    if (selectedTag === AllTag) {
        filteredBlogs = reversedBlogData;
    }

    // Handler for clicking a tag in this page
    const handleTagClick = (tag) => {
        setSelectedTag(tag);
        setSearchParams({ tag: tag === AllTag ? "" : tag });
        window.scrollTo(0, 0);
    };

    return (
        <>
            <Navbar />
            <div className="blog-section container">
                <div className="blog-header text-center">
                    <img src="/Images/ActiviKid-Cat-head.svg" alt="ActiviKid Cat" className="blog-cat-icon" />
                    <div className="blog-title-container">
                        <h1 className="section-main-title">{t('blog_page.title')}</h1>
                        <img src="/Images/ActiviKid-spark.svg" alt="Spark" className="blog-spark-icon" />
                    </div>
                </div>
                {/* Horizontally scrollable tags bar */}
                <div className="tag-row">
                    <div className="all-blog-tags">
                        <ul className="tag-links list-inline mb-0">
                            {availableTags.map((tag, index) => (
                                <li className="list-inline-item" key={index}>
                                    <Link
                                        to={`/blogs?tag=${encodeURIComponent(tag)}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleTagClick(tag);
                                        }}
                                        className={tag === selectedTag ? "tag-active" : ""}
                                    >
                                        {tag}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <hr style={{color: "rgba(0,0,0,0.7)", marginTop: "0", marginBottom: "3rem"}}/>
                <div className="blog-page-container container">
                    {filteredBlogs.map((blog, index) => (
                        <BlogPost key={index} blog={blog}/>
                    ))}
                </div>
            </div>
            <Footer/>
        </>
    );
}

export default BlogPage;
